export const healthArray = ['HEALTH-1', 'HEALTH-2']